import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=09bcff30&scoped=true&"
import script from "./CardFooter.vue?vue&type=script&lang=js&"
export * from "./CardFooter.vue?vue&type=script&lang=js&"
import style0 from "./CardFooter.vue?vue&type=style&index=0&id=09bcff30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bcff30",
  null
  
)

export default component.exports